import * as types from './action-types';
import {getAppBySlug} from '../services/market-api';
import {errorPage} from './mode';

export function requestApp(slug) {
  return {
    type: types.REQUEST_APP,
    slug
  };
}

export function receiveApp(slug, json) {
  return {
    type: types.RECEIVE_APP,
    slug,
    data: json ? {...json} : {},
    receivedAt: json ? Date.now() : 0
  };
}

function fetchApp(slug, lang) {
  return dispatch => {
    dispatch(requestApp(slug));

    return getAppBySlug(slug, lang)
      .then(json => dispatch(receiveApp(slug, json)))
      .catch((err) => {
        dispatch(errorPage(err.message, err._responseStatus));
        return dispatch(receiveApp(slug));
      });
  };
}


export function fetchAppIfNeeded(slug = '') {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.apps.list[slug]) {
      return dispatch(fetchApp(slug, state.mode.lang));
    } else {
      return Promise.resolve(state.apps.list[slug]);
    }
  };
}

export function openApp(slug) {
  return {
    type: types.OPEN_APP,
    slug
  };
}



// WEBPACK FOOTER //
// ./actions/apps.js